import React, { useState } from "react";

export default function Age({ onChange }) {
    const [years, setYears] = useState("");
    const [months, setMonths] = useState("");
    const [error, setError] = useState("");

    const handleYearChange = (event) => {
        const newYears = event.target.value.replace(/[^0-9]/g, "");
        setYears(newYears);
        updateAge(newYears, months);
    };

    const handleMonthChange = (event) => {
        const newMonths = event.target.value.replace(/[^0-9]/g, "");
        setMonths(newMonths);
        updateAge(years, newMonths);
    };

    const updateAge = (years, months) => {
        const decimalMonths = months ? parseInt(months) / 12 : 0;
        const totalAge = years ? parseInt(years) + decimalMonths : decimalMonths;

        if (totalAge < 5 || totalAge > 19) {
            setError("L'âge doit être entre 5 et 19 ans.");
        } else {
            setError("");
            onChange(totalAge);
        }
    };

    return (
        <div className="text-sm sm:text-base mb-2 cursor-default">


            <div
                className="text-sm sm:text-base mb-2 cursor-default"
                id="AgeLabel"
            >
                L'âge de votre enfant
            </div>

            <div className="flex gap-8">
                <div className="flex items-center gap-2">
                    <input
                        type="text"
                        inputMode="numeric"
                        className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
                        onChange={handleYearChange}
                        value={years}
                        aria-labelledby="AgeLabel"
                        aria-describedby="AgeDescription"
                        role="spinbutton"
                        aria-valuenow={years}
                    />
                    <div className="text-base sm:text-xl font-bold cursor-default">ans</div>
                </div>
                <div className="flex items-center gap-2">
                    <input
                        type="text"
                        inputMode="numeric"
                        className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
                        onChange={handleMonthChange}
                        value={months}
                        aria-labelledby="AgeLabel"
                        aria-describedby="AgeDescription"
                        role="spinbutton"
                        aria-valuenow={months}
                    />
                    <div className="text-base sm:text-xl font-bold cursor-default">mois</div>
                </div>
            </div>
            {/* Error message always present, but visibility toggles */}
            <div className="text-red-500 text-xs sm:text-sm mt-2 h-6">
                {error || " "}
            </div>
        </div>
    );
}
